module.exports = __webpack_public_path__ + "img/home-07-cosmopolitan-cerita-05.6f54eaa4.jpg";